import { useQuery } from "@apollo/client";
import { ConditionalType } from "@regal-voice/shared-types";

import { getEventFields } from "ServerData/EventSchema/queries";
import { NodeTriggerType } from "Types/Journey";

import { getEventType } from "../../shared/helpers";

export function useQueryEventAttributes(event: { eventType?: NodeTriggerType | ConditionalType; eventName?: string }): {
    loading: boolean;
    eventAttributes: Record<string, string>[];
} {
    const { loading, data } = useQuery(getEventFields, {
        notifyOnNetworkStatusChange: true,
        fetchPolicy: "no-cache",
        skip: !event?.eventType || !event?.eventName,
        variables: {
            eventType: getEventType(event?.eventType as NodeTriggerType),
            eventName: event.eventName,
        },
    });
    const eventAttributes = data?.getEventSchema || [];
    return { loading, eventAttributes };
}
